import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function FA_FAQ_comp() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='mt-5'>
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography className='fs-5'>WHAT’S A CREDIT SCORE?   </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          A credit score is a numeric rating creditor use to assess borrower risk in making lending decisions. The most commonly used credit score is from FICO. This rating is defined by how much debt you have, whether you pay your bills on time, how many credit cards you have and any unpaid bills, among other factors.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-5'>WHAT DOES INVESTING MEAN?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Investing means sinking your money into a venture — in the form of companies, commodities or even real estate — so that your money can make more money. The easiest way to begin investing is with your retirement account, but there are many ways to invest. Contrary to popular opinion, you don’t need a ton of money to do it.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-5'>WHAT IS ‘GOOD DEBT’?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            While there are some general, personal questions to ask yourself when assessing which debts are worth it, only you can really determine whether your debt is good or bad.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
    </div>
  );
}
